import * as React from 'react'
import { useNotify, useTranslate } from 'react-admin'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import dayjs from 'dayjs'
import { CONFIRMED } from '../../common/state'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { LoadingButton } from '@mui/lab'
import { billingServices } from 'src/services/reservation/billing/billing.service'

export const InvalidateJournalEntryModal = ({
  openModal,
  selectedItem,
  setOpenModal,
  onComplete
}) => {
  const theme = useTheme()
  const notify = useNotify()
  const translate = useTranslate()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [loadingJournalEntry, setLoadingJournalEntry] = React.useState(false)

  const tableHeaders = [
    'number_journal_entry',
    'date',
    'amount'
  ]

  const onSubmit = async () =>{
    setLoadingJournalEntry(true)
    const promises = selectedItem?.journal_entry
      ?.filter(elem => elem.status === CONFIRMED)
      ?.map(elem => billingServices.invalidateJournalEntryItem(elem.id))
    Promise.all(promises).then(() => {
      notify('ra.notification.invalidate_provision_success', { type: 'success' })
      onComplete?.()
    }).catch((e)=>{
      notify('ra.notification.invalidate_provision_error', { type: 'error' })
    }).finally(()=>{
      setLoadingJournalEntry(false)
    })
  }

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth='sm'
        fullScreen={fullScreen}
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <DialogTitle>
          {`${translate('ra.action.invalidate')} ${translate('ra.field.provision').toLowerCase()}`}
        </DialogTitle>

        <DialogContent>
          <Typography>
            {translate('ra.message.invalidate_provision')}
          </Typography>

          <Table>
            <TableHead>
              <TableRow>
                {tableHeaders.map((header, i) => (
                  <TableCell key={i}>
                    {translate(`ra.field.${header}`)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {selectedItem?.journal_entry?.filter(elem => elem.status === CONFIRMED)?.map((entry, i) => (
                <TableRow key={i}>
                  <TableCell>{entry.nro}</TableCell>
                  <TableCell>{entry.date ? dayjs(entry.date).format('DD/MM/YYYY') : '-'}</TableCell>
                  <TableCell align='right'>{entry.currency} {numberFormatterWithDecimalAndThousand(entry.amount)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>

        <DialogActions>
          <Button
            variant='outlined'
            color='error'
            onClick={() => setOpenModal(false)}
            disabled={loadingJournalEntry}
          >
            {translate('ra.action.cancel')}
          </Button>
          <LoadingButton
            variant='contained'
            onClick={onSubmit}
            loading={loadingJournalEntry}
          >
            {translate('ra.action.to_confirm')}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}
